// extracted by mini-css-extract-plugin
export default {"PreferredAreaItem":"styles_PreferredAreaItem__NxFFe","PreferredAreaItemActive":"styles_PreferredAreaItemActive__4PWkV"};